import classNames from 'classnames';
import React, { forwardRef, useId } from 'react';
import FormControl from '../FormControl';
import './Textarea.scss';

export interface TextareaProps {
  label: React.ReactNode | React.ReactNode[];
  type?: 'text' | 'tel' | 'password' | 'number' | 'url' | 'search' | 'email';
  name: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  error?: string | boolean;
  value?: string | number;
  defaultValue?: string | number;
  helpText?: React.ReactNode | React.ReactNode[];
  hideLabel?: boolean;
  tooltip?: React.ReactNode | React.ReactNode[];
  tooltipAriaLabel?: string;
  inputProps?: React.InputHTMLAttributes<HTMLTextAreaElement>;
  pii?: boolean;
  rows?: number;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      name,
      placeholder,
      disabled = false,
      required = false,
      pii = false,
      rows = 5,
      value,
      defaultValue,
      error,
      tooltip,
      tooltipAriaLabel,
      helpText,
      hideLabel,
      onChange,
      onBlur,
      onFocus,
      inputProps = {}
    },
    ref
  ) => {
    const id = useId();

    const classes = classNames('zb-textarea mss-textarea', {
      'zb-textarea-is-error': !!error
    });

    return (
      <FormControl
        label={label}
        id={id}
        tooltip={tooltip}
        tooltipAriaLabel={tooltipAriaLabel}
        helpText={helpText}
        error={error}
        hideLabel={hideLabel}
        required={required}
        pii={pii}
      >
        <textarea
          id={id}
          name={name}
          className={classes}
          placeholder={placeholder}
          disabled={disabled}
          aria-invalid={!!error}
          aria-describedby={error ? `error-${id}` : undefined}
          aria-required={required}
          rows={rows}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          ref={ref}
          {...inputProps}
        />
      </FormControl>
    );
  }
);

export default Textarea;
